import {Mark} from 'tiptap';
import {markInputRule, updateMark, removeMark} from 'tiptap-commands';

/**
 * Color - Extends the built in Mark from tiptap allowing
 * the editor to set the color.
 */

export default class Highlight extends Mark {
  get name() {
    return 'highlight';
  }

  get schema() {
    return {
      attrs: {
        type: {default: ''},
        color: {default: ''},
      },
      parseDOM: [
        {
          tag: '[data-highlight]',
          getAttrs: (dom) => {
            return {
              color: getCssVarFromEl('--highlight-color', dom),
              type: dom.getAttribute('data-highlight'),
            };
          },
        },
      ],

      toDOM: (node) => [
        'span',
        {
          'data-highlight': node.attrs.type,
          style: `--highlight-color: ${node.attrs.color}`,
        },
        0,
      ],
    };
  }

  commands({type}) {
    return (attrs) => {
      if (attrs.type && attrs.type !== 'none') {
        return updateMark(type, attrs);
      }
      return removeMark(type);
    };
  }

  // inputRules({type}) {
  //   return [markInputRule(/(?:\*\*|__)([^*_]+)(?:\*\*|__)$/, type)];
  // }
}

function getCssVarFromEl(prop, el) {
  try {
    const cssText = el.style.cssText;
    const theProp = cssText.split('; ').find((style) => style.includes(prop));
    const propValue = theProp.slice(
      theProp.indexOf(':') + 1,
      theProp.indexOf(';'),
    );
    return propValue.trim();
  } catch (e) {
    return '';
  }
}
